import { classNames, h, tag } from "omi";
import isEmpty from "lodash-es/isEmpty";

import { COMMUNITY_LINK } from "@/globals/links.ts";
import { tailwind } from "@/tailwind";

import { DocBase } from "../docBase.tsx";
import { DocumentTheme, DocumentThemeDef } from "../models.ts";
import { NWDocUser } from "../nw-doc-user";
import type { DocumentPageProps } from "./models.ts";
import styles from "./style.css?inline";

@tag("nw-doc-page-content")
export class ContentPage extends DocBase<DocumentPageProps> {
  static css = [tailwind, styles];

  static propTypes = {
    type: String,
    title: String,
    usersname: String,
    userlink: String,
    usersavatar: String,
    theme: String,
  };

  render({ usersname, usersavatar, theme, title }: DocumentPageProps) {
    const themeDef = DocumentThemeDef[theme || DocumentTheme.LIGHT];

    return (
      <div class={classNames("w-[762px] h-screen page relative z-[1]", themeDef.background)}>
        <div class="border-l absolute top-0 bottom-0"></div>

        <div class="w-full">
          <div class="pl-12 flex items-center pb-4">
            <div class="flex justify-between items-end w-full">
              <NWDocUser name={usersname ?? ""} link={"nextwork.org/"} imgSrc={usersavatar} theme={theme} />
              <a href={COMMUNITY_LINK} target="_blank" class={classNames("underline text-xl", themeDef.font)}>
                nextwork.org
              </a>
            </div>
          </div>

          <div class="border-b absolute right-0 left-0 mb-12"></div>

          <div class="px-12 mt-12">
            {!isEmpty(title) && (
              <h1 id="heading" class={classNames("font-medium text-4xl tracking-tight", themeDef.font)}>
                {title}
              </h1>
            )}

            <div id="container">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
